import { useState } from "react";
import { PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/solid';

export default function NavBar() {

  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">

          {/* Left: Logo + Links */}
          <div className="flex items-center space-x-8">
            <a href="/" className="text-lg font-bold text-gray-800">OLQM</a>
            <div className="hidden md:flex space-x-3">
              <a href="/" className="text-gray-700 hover:bg-blue-100 px-3 py-2 rounded-md text-sm font-medium">Home</a>
              <a href="/about-us" className="text-gray-700 hover:bg-blue-100 px-3 py-2 rounded-md text-sm font-medium">About Us</a>
              <a href="/news-letters" className="text-gray-700 hover:bg-blue-100 px-3 py-2 rounded-md text-sm font-medium">News Letters</a>
              <a href="/news-and-events" className="text-gray-700 hover:bg-blue-100 px-3 py-2 rounded-md text-sm font-medium">News and Events</a>
              <a href="/sacraments" className="text-gray-700 hover:bg-blue-100 px-3 py-2 rounded-md text-sm font-medium">Sacraments</a>
              <a href="/parish-groups" className="text-gray-700 hover:bg-blue-100 px-3 py-2 rounded-md text-sm font-medium">Parish Groups</a>
              <a href="/contact-us" className="text-gray-700 hover:bg-blue-100 px-3 py-2 rounded-md text-sm font-medium">Contact</a>
              <a href="/gallery" className="text-gray-700 hover:bg-blue-100 px-3 py-2 rounded-md text-sm font-medium">Gallery</a>
            </div>
          </div>

          {/* Right: Contact Info */}
          <div className="hidden md:flex items-center space-x-4 text-sm text-gray-600">
            <div className="flex items-center space-x-1">
              <PhoneIcon className="w-4 h-4 text-blue-500" />
              <span>0151 546 3574</span>
            </div>
            <div className="flex items-center space-x-1">
              <EnvelopeIcon className="w-4 h-4 text-blue-500" />
              <span>olqom@rcaol.org.uk</span>
            </div>
          </div>

          {/* Hamburger Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700 hover:text-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-400 rounded"
              aria-label="Toggle menu"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                {isOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Dropdown */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 px-4 pb-4 space-y-1">
          <a href="/" className="block text-gray-700 hover:bg-blue-100 hover:text-blue-500 px-3 py-2 rounded-md">Home</a>
          <a href="/about-us" className="block text-gray-700 hover:bg-blue-100 hover:text-blue-500 px-3 py-2 rounded-md">About Us</a>
          <a href="/news-letters" className="block text-gray-700 hover:bg-blue-100 hover:text-blue-500 px-3 py-2 rounded-md">News Letters</a>
          <a href="/news-and-events" className="block text-gray-700 hover:bg-blue-100 hover:text-blue-500 px-3 py-2 rounded-md">News and Events</a>
          <a href="/sacraments" className="block text-gray-700 hover:bg-blue-100 hover:text-blue-500 px-3 py-2 rounded-md">Sacraments</a>
          <a href="/parish-groups" className="block text-gray-700 hover:bg-blue-100 hover:text-blue-500 px-3 py-2 rounded-md">Parish Groups</a>
          <a href="/contact-us" className="block text-gray-700 hover:bg-blue-100 hover:text-blue-500 px-3 py-2 rounded-md">Contact</a>
          <a href="/gallery" className="block text-gray-700 hover:bg-blue-100 hover:text-blue-500 px-3 py-2 rounded-md">Gallery</a>          

          {/* Mobile Contact Info */}
          <div className="mt-4 px-4 pb-4 border-t pt-4 text-sm text-gray-700 space-y-2">
            <div className="flex items-center space-x-2">
              <PhoneIcon className="w-4 h-4 text-blue-500" />
              <a href="tel:0151 546 3574" className="hover:text-blue-600">0151 546 3574</a>
            </div>
            <div className="flex items-center space-x-2">
              <EnvelopeIcon className="w-4 h-4 text-blue-500" />
              <a href="mailto:olqom@rcaol.org.uk" className="hover:text-blue-600">olqom@rcaol.org.uk</a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}